import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import navIcon1 from '../../assets/img/nav-icon1.svg';
import navIcon2 from '../../assets/img/nav-icon2.svg';
import navIcon3 from '../../assets/img/nav-icon3.svg';
import { HashLink } from 'react-router-hash-link';


export const HeaderPrinting = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
   
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
        <Nav.Link  href="/"><h5>Totle<span className='chris'>Soft</span></h5></Nav.Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
              <Nav.Link href="#service" className={activeLink === 'service' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('service')}>Services</Nav.Link>
              <Nav.Link href="#samples" className={activeLink === 'samples' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('samples')}>Samples</Nav.Link>
              <Nav.Link href="#products" className={activeLink === 'products' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('products')}>Products</Nav.Link>
              <Nav.Link href="#testimony" className={activeLink === 'testimony' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('testimony')}>Testimonies</Nav.Link>
              
              </Nav>
            
            <span className="navbar-text">
            <div className="social-icon">
              <a href="https://www.linkedin.com/company/totlesoft/"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://www.facebook.com/totlesoftmedia/"><img src={navIcon2} alt="Icon" /></a>
              <a href="https://www.instagram.com/totlesoft/"><img src={navIcon3} alt="Icon" /></a>
            </div>
              <HashLink to='#connect'>
                <button className="vvd"><span>Let’s Connect</span></button>
              </HashLink>
            </span>
            
          </Navbar.Collapse>
        </Container>
      </Navbar>
   
  )
}
